import { render, staticRenderFns } from "./ContactUsBody.vue?vue&type=template&id=1322f4d6&"
import script from "./ContactUsBody.vue?vue&type=script&scoped=true&lang=js&"
export * from "./ContactUsBody.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./ContactUsBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1322f4d6')) {
      api.createRecord('1322f4d6', component.options)
    } else {
      api.reload('1322f4d6', component.options)
    }
    module.hot.accept("./ContactUsBody.vue?vue&type=template&id=1322f4d6&", function () {
      api.rerender('1322f4d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/AboutUs/ContactUs/ContactUsBody.vue"
export default component.exports